/**
 * Любой отказ в доступе по коду — один и тот же ключ перевода. Отличай мы «кода нет» от
 * «код неверный», по случайному коду было бы видно, есть ли у чужого email записи: код
 * заводится только при активных бронях. По той же причине клиенту не сообщается, что код
 * сгорел.
 *
 * Отдельный файл, а не сервис: константу читает и браузерный диалог, а сервис тянет
 * `node:crypto`.
 */
export const MEETING_ACCESS_CODE_REJECTED = "meeting_access_code_rejected";
